// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb li[data-v-4f3628fc],.breadcrumb li a[data-v-4f3628fc]{font-size:16px;font-weight:300;line-height:19px;color:#3c484d}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
